import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-035cb991"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Team Scoreboard", -1))
const _hoisted_3 = {
  key: 0,
  class: "label"
}
const _hoisted_4 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchBox = _resolveComponent("SearchBox")!
  const _component_MobileSelectMetric = _resolveComponent("MobileSelectMetric")!
  const _component_NPSResponsesPlot = _resolveComponent("NPSResponsesPlot")!
  const _component_NPSPlotValueList = _resolveComponent("NPSPlotValueList")!
  const _component_BaseBlock = _resolveComponent("BaseBlock")!

  return (_openBlock(), _createBlock(_component_BaseBlock, null, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.tsTeamGroups.length > 1)
          ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTeamGroupKey) = $event)),
                class: "input",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectGroup && _ctx.selectGroup(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tsTeamGroups, (group) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: group.groupName,
                    value: _ctx.getTeamgroupKey(group)
                  }, _toDisplayString(group.groupName), 9, _hoisted_4))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.selectedTeamGroupKey]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_SearchBox, {
        value: _ctx.searchText,
        rounded: false,
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchText = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_MobileSelectMetric, {
        class: "metric-selector",
        "no-pad": ""
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_NPSResponsesPlot, { "team-scoreboard": _ctx.teamScoreboard }, null, 8, ["team-scoreboard"]),
      _createVNode(_component_NPSPlotValueList, {
        "ts-group-summary": _ctx.tsGroupSummary,
        "visible-items": _ctx.visibleItems,
        fields: _ctx.fields,
        onShowDetail: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('showDetail')))
      }, null, 8, ["ts-group-summary", "visible-items", "fields"])
    ], undefined, true),
    _: 1
  }))
}